var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeterBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2499 6.24999L8.2499 5.24999M5.7499 4.74999L6.7499 3.74999M4.2499 3.24999L5.2499 2.24999M8.7499 7.74999L9.7499 6.74999M10.6499 7.64999C10.7618 7.76148 10.8505 7.89395 10.9111 8.03981C10.9717 8.18567 11.0028 8.34206 11.0028 8.49999C11.0028 8.65793 10.9717 8.81431 10.9111 8.96017C10.8505 9.10604 10.7618 9.23851 10.6499 9.34999L9.3499 10.65C9.23842 10.7619 9.10594 10.8506 8.96008 10.9112C8.81422 10.9718 8.65784 11.0029 8.4999 11.0029C8.34196 11.0029 8.18558 10.9718 8.03972 10.9112C7.89386 10.8506 7.76139 10.7619 7.6499 10.65L1.3499 4.34999C1.12518 4.12418 0.999023 3.81857 0.999023 3.49999C0.999023 3.18142 1.12518 2.8758 1.3499 2.64999L2.6499 1.34999C2.87571 1.12527 3.18133 0.999115 3.4999 0.999115C3.81848 0.999115 4.12409 1.12527 4.3499 1.34999L10.6499 7.64999Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeterBlack);
export default __webpack_public_path__ + "static/media/meterBlack.0bbdc93027e9fbe40fce9ccce69c0a84.svg";
export { ForwardRef as ReactComponent };